<h1 mat-dialog-title>{{ 'archive_media_item_dialog.title' | translate }}</h1>
<div mat-dialog-content>
  @if (!loaded) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (usage.length === 0 && notAllowedToViewAmount === 0) {
    <p>{{ 'archive_media_item_dialog.item.removeable' | translate }}</p>
  }
  @if (usage.length === 0 && notAllowedToViewAmount !== 0) {
    <p>
      {{ 'archive_media_item_dialog.item.in_use.unauthorized' | translate: { usageCount: notAllowedToViewAmount} }}
    </p>
  }
  @if (usage.length > 0) {
    <p>{{ 'archive_media_item_dialog.item.in_use' | translate }}</p>
    <mat-selection-list #shoes [multiple]="false">
      @for (usedBy of usage; track usedBy) {
        <mat-list-option [value]="usedBy" (click)="navigateTo(usedBy)">
          @if (usedBy.src === 'activity') {
            <mat-icon matListItemIcon>filter_none</mat-icon>
          }
          @if (usedBy.src === 'program') {
            <mat-icon matListItemIcon>calendar_today</mat-icon>
          }
          @if (['attachment', 'template_attachment', 'template_bundle_attachment'].includes(usedBy.src)) {
            <mat-icon matListItemIcon>attach_file</mat-icon>
          }
          @if (usedBy.src === 'user_media') {
            <mat-icon matListItemIcon>account_circle</mat-icon>
          }
          @if (usedBy.src === 'jibbie_activity') {
            <mat-icon matListItemIcon svgIcon="jibbie-linked"></mat-icon>
          }
          <div matListItemLine>{{usedBy.src_name}}</div>
          <div matListItemLine class="ownership">{{ownershipDescription(usedBy)}}</div>
        </mat-list-option>
      }
    </mat-selection-list>
    @if (notAllowedToViewAmount > 0) {
      <p>
        {{ 'archive_media_item_dialog.item.in_use.additional_unauthorized' | translate: {usageCount: notAllowedToViewAmount} }}
      </p>
    }
  }
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ 'generic.cancel' | translate | uppercase }}</button>
  <span class="spacer"></span>
  <button mat-button [disabled]="archivingInProgress || !loaded || usage.length > 0" (click)="confirm()" color="primary" cdkFocusInitial>
    {{ 'generic.archive' | translate | uppercase  }}
  </button>
  @if (archivingInProgress) {
    <mat-progress-spinner
      diameter="30"
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
</div>

